setTimeout(() => {
    document.querySelector('body[cloak]')?.removeAttribute('cloak');
}, 1000);
